module.exports = __webpack_public_path__ + "img/copy.b8b31515.svg";